module.exports = __webpack_public_path__ + "img/phone.6cc54ee2.png";